module.exports = __webpack_public_path__ + "static/media/logo-with-icons-navy.b86757b2.svg";